import {
  ByIdPayload,
  FailByIdPayload,
  NormalizedSingle,
  OperationReducerTypes,
  PayloadAction,
  SendByIdPayload,
  SuccessByIdPayload,
  uniqueActionType
} from '@industi/ngx-common';
import { Model } from '../models/model';

export const ModelEditActionTypes: OperationReducerTypes = {
  request: uniqueActionType('[model] Edit'),
  requestFail: uniqueActionType('[model] Edit fail'),
  requestSuccess: uniqueActionType('[model] Edit success'),
  requestClearErrors: uniqueActionType('[model] Edit clear errors'),
  requestClear: uniqueActionType('[model] Edit clear')
};

export class ModelEditAction implements PayloadAction {
  readonly type = ModelEditActionTypes.request;

  constructor(public payload: SendByIdPayload<Model>) {
  }
}

export class ModelEditFailAction implements PayloadAction {
  readonly type = ModelEditActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class ModelEditSuccessAction implements PayloadAction {
  readonly type = ModelEditActionTypes.requestSuccess;

  constructor(public payload: SuccessByIdPayload<NormalizedSingle>) {
  }
}

export class ModelEditClearErrorsAction implements PayloadAction {
  readonly type = ModelEditActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}

export class ModelEditClearAction implements PayloadAction {
  readonly type = ModelEditActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}
